module.exports = __webpack_public_path__ + "img/img7.4a22a8c4.png";